import { css } from 'lit';
const styles = css`.cre8-u-content-knockout-brand {
  color: var(--cre8-color-content-knockout-brand);
}

.cre8-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

.cre8-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

@media all and (min-width: 23.4375rem) {
  .cre8-u-hide-sm {
    display: none !important;
  }
}
@media all and (min-width: 35rem) {
  .cre8-u-hide-sm-2 {
    display: none !important;
  }
}
@media all and (min-width: 48rem) {
  .cre8-u-hide-md {
    display: none !important;
  }
}
@media all and (min-width: 60rem) {
  .cre8-u-hide-lg {
    display: none !important;
  }
}
@media all and (min-width: 75rem) {
  .cre8-u-hide-xl {
    display: none !important;
  }
}
@media all and (max-width: 23.4375rem) {
  .cre8-u-show-sm {
    display: none !important;
  }
}
@media all and (max-width: 35rem) {
  .cre8-u-show-sm-2 {
    display: none !important;
  }
}
@media all and (max-width: 48rem) {
  .cre8-u-show-md {
    display: none !important;
  }
}
@media all and (max-width: 60rem) {
  .cre8-u-show-lg {
    display: none !important;
  }
}
@media all and (max-width: 75rem) {
  .cre8-u-show-xl {
    display: none !important;
  }
}
.cre8-u-margin-none {
  margin: 0 !important;
}

.cre8-u-margin-sm {
  margin: 0.5rem !important;
}

.cre8-u-margin-md {
  margin: 1rem !important;
}

.cre8-u-margin-lg {
  margin: 1.5rem !important;
}

.cre8-u-margin-xl {
  margin: 2rem !important;
}

.cre8-u-margin-xxl {
  margin: 4rem !important;
}

.cre8-u-margin-top-none {
  margin-top: 0 !important;
}

.cre8-u-margin-top-sm {
  margin-top: 0.5rem !important;
}

.cre8-u-margin-top-md {
  margin-top: 1rem !important;
}

.cre8-u-margin-top-lg {
  margin-top: 1.5rem !important;
}

.cre8-u-margin-top-xl {
  margin-top: 2rem !important;
}

.cre8-u-margin-top-xxl {
  margin-top: 4rem !important;
}

.cre8-u-margin-right-none {
  margin-right: 0 !important;
}

.cre8-u-margin-right-sm {
  margin-right: 0.5rem !important;
}

.cre8-u-margin-right-md {
  margin-right: 1rem !important;
}

.cre8-u-margin-right-lg {
  margin-right: 1.5rem !important;
}

.cre8-u-margin-right-xl {
  margin-right: 2rem !important;
}

.cre8-u-margin-right-xxl {
  margin-right: 4rem !important;
}

.cre8-u-margin-bottom-none {
  margin-bottom: 0 !important;
}

.cre8-u-margin-bottom-sm {
  margin-bottom: 0.5rem !important;
}

.cre8-u-margin-bottom-md {
  margin-bottom: 1rem !important;
}

.cre8-u-margin-bottom-lg {
  margin-bottom: 1.5rem !important;
}

.cre8-u-margin-bottom-xl {
  margin-bottom: 2rem !important;
}

.cre8-u-margin-bottom-xxl {
  margin-bottom: 4rem !important;
}

.cre8-u-margin-bottom-xl-xxl {
  margin-bottom: 2rem !important;
}

@media all and (min-width: 768px) {
  .cre8-u-margin-bottom-xl-xxl {
    margin-bottom: 4rem !important;
  }
}
.cre8-u-margin-left-none {
  margin-left: 0 !important;
}

.cre8-u-margin-left-sm {
  margin-left: 0.5rem !important;
}

.cre8-u-margin-left-md {
  margin-left: 1rem !important;
}

.cre8-u-margin-left-lg {
  margin-left: 1.5rem !important;
}

.cre8-u-margin-left-xl {
  margin-left: 2rem !important;
}

.cre8-u-margin-left-xxl {
  margin-left: 4rem !important;
}

.cre8-u-padding-none {
  padding: 0 !important;
}

.cre8-u-padding-sm {
  padding: 0.5rem !important;
}

.cre8-u-padding-md {
  padding: 1rem !important;
}

.cre8-u-padding-lg {
  padding: 1.5rem !important;
}

.cre8-u-padding-xl {
  padding: 2rem !important;
}

.cre8-u-padding-xxl {
  padding: 4rem !important;
}

.cre8-u-padding-top-none {
  padding-top: 0 !important;
}

.cre8-u-padding-top-sm {
  padding-top: 0.5rem !important;
}

.cre8-u-padding-top-md {
  padding-top: 1rem !important;
}

.cre8-u-padding-top-lg {
  padding-top: 1.5rem !important;
}

.cre8-u-padding-top-xl {
  padding-top: 2rem !important;
}

.cre8-u-padding-top-xxl {
  padding-top: 4rem !important;
}

.cre8-u-padding-right-none {
  padding-right: 0 !important;
}

.cre8-u-padding-right-sm {
  padding-right: 0.5rem !important;
}

.cre8-u-padding-right-md {
  padding-right: 1rem !important;
}

.cre8-u-padding-right-lg {
  padding-right: 1.5rem !important;
}

.cre8-u-padding-right-xl {
  padding-right: 2rem !important;
}

.cre8-u-padding-right-xxl {
  padding-right: 4rem !important;
}

.cre8-u-padding-bottom-none {
  padding-bottom: 0 !important;
}

.cre8-u-padding-bottom-sm {
  padding-bottom: 0.5rem !important;
}

.cre8-u-padding-bottom-md {
  padding-bottom: 1rem !important;
}

.cre8-u-padding-bottom-lg {
  padding-bottom: 1.5rem !important;
}

.cre8-u-padding-bottom-xl {
  padding-bottom: 2rem !important;
}

.cre8-u-padding-bottom-xxl {
  padding-bottom: 4rem !important;
}

.cre8-u-padding-left-none {
  padding-left: 0 !important;
}

.cre8-u-padding-left-sm {
  padding-left: 0.5rem !important;
}

.cre8-u-padding-left-md {
  padding-left: 1rem !important;
}

.cre8-u-padding-left-lg {
  padding-left: 1.5rem !important;
}

.cre8-u-padding-left-xl {
  padding-left: 2rem !important;
}

.cre8-u-padding-left-xxl {
  padding-left: 4rem !important;
}

.cre8-u-display-flex {
  display: flex !important;
}

.cre8-u-display-block {
  display: block !important;
}

body {
  font-family: var(--cre8-typography-body-default-font-family);
  font-size: var(--cre8-typography-body-default-font-size);
  font-weight: var(--cre8-typography-body-default-font-weight);
  line-height: var(--cre8-typography-body-default-line-height);
  text-decoration: var(--cre8-typography-body-default-text-decoration);
  text-transform: var(--cre8-typography-body-default-text-transform);
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  color: var(--cre8-color-content-default);
  background: var(--cre8-color-bg-default);
}

@media all and (min-width: 60rem) {
  .page-container {
    background: linear-gradient(90deg, #fff 0, #fff 66.66%, #f8f8f9 0, #f8f8f9 0);
  }
}
.band__inner {
  margin-left: 2rem;
  margin-right: 2rem;
}

@media all and (min-width: 60rem) {
  .band__inner {
    margin-right: 0;
  }
}
img {
  max-width: 100%;
  height: auto;
}

/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:root {
  --size-base-unit: 0.5rem;
  --cre8-l-max-width: 82.5rem;
  /* 1 */
  --cre8-l-linelength-width: 42rem;
  /* 1 */
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to-right" or "to-left" need to be switched to using deg values.
 * 3) Inverse items that have 45degs
 */
[dir=rtl] {
  --rtlTranslateX: 50%;
  /* 1 */
  --rtlGradientToRight: 270deg;
  /* 2 */
  --rtlRotate45Inverse: -45deg;
  /* 3 */
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements with an error status
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
* Focus state for themes that need a dashed outline for focus
* state
**/
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/*
=======
Animations
=======
*/
:host {
  --cre8-z-index-1: 1;
  --cre8-z-index-50: 50;
  --cre8-z-index-100: 100;
  --cre8-z-index-200: 200;
  --cre8-z-index-1030: 1030;
  --cre8-anim-fade-quick: 0.35s;
  --cre8-anim-ease: ease;
}

@keyframes fadeIn {
  100% {
    opacity: 1;
  }
}
@keyframes slideIn {
  100% {
    transform: translateX(0);
  }
}
@keyframes slideInFwd {
  100% {
    width: 272px;
    height: 272px;
  }
}
@keyframes slideOutRight {
  100% {
    width: 272px;
    height: 272px;
  }
}
@keyframes slideUp {
  100% {
    transform: translateY(0);
  }
}
@media (width >= 481px) {
  @keyframes slideInFwd {
    100% {
      width: 417px;
      height: 417px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 417px;
      height: 417px;
    }
  }
}
@media (width >= 48rem) {
  @keyframes slideInFwd {
    100% {
      width: 330px;
      height: 330px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 330px;
      height: 330px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 60rem) {
  @keyframes slideInFwd {
    100% {
      width: 460px;
      height: 460px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 460px;
      height: 460px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 75rem) {
  @keyframes slideInFwd {
    100% {
      width: 592px;
      height: 591px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 87.5rem) {
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 120px));
    }
  }
}
@media (width >= 2200px) {
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 592px));
    }
  }
}
span.ripple {
  position: absolute;
  border-radius: 50%;
  transform: scale(0);
  animation: ripple 600ms linear;
  background-color: var(--ripple-bg-color);
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 1;
  }
}
:root {
  --size-base-unit: 0.5rem;
  --cre8-l-max-width: 82.5rem;
  /* 1 */
  --cre8-l-linelength-width: 42rem;
  /* 1 */
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to-right" or "to-left" need to be switched to using deg values.
 * 3) Inverse items that have 45degs
 */
[dir=rtl] {
  --rtlTranslateX: 50%;
  /* 1 */
  --rtlGradientToRight: 270deg;
  /* 2 */
  --rtlRotate45Inverse: -45deg;
  /* 3 */
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements with an error status
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
* Focus state for themes that need a dashed outline for focus
* state
**/
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
:host {
  display: block;
}

/**
 * 1) A card is an organized block that typically contains a title, image,
 * text, and/or calls to action. It is made up of an optional header slot, required
 * body slot, and optional footer slot to place other Components and content within.
 */
.cre8-c-card {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: var(--cre8-padding-24);
  gap: var(--cre8-padding-16);
  border-color: var(--cre8-color-border-default);
  border-style: var(--cre8-border-style-default);
  border-width: var(--cre8-border-width-default);
  border-radius: var(--cre8-border-radius-container);
  background: var(--cre8-color-bg-default);
}

/**
 * Full height card
 * 1) Stretches the card to fill its parent's height and width. Off by
 * default: the host is \`display: block\` with no explicit height, so a card
 * placed in a flex or grid ancestor with \`align-items: stretch\` would
 * otherwise inherit whatever height that ancestor happens to establish -
 * invisible from outside the shadow boundary and unrelated to the card's
 * own content. Opt in only when the parent's height is actually meant to be
 * shared, e.g. cards as flex/grid items that should line up edge to edge.
 */
.cre8-c-card--full-height {
  height: 100%;
  width: 100%;
}

/**
 * Compact card - reduced padding for narrow layouts
 */
.cre8-c-card--compact {
  padding: var(--cre8-padding-16);
  gap: var(--cre8-padding-8);
}

/**
 * Horizontal card
 * 1) Organized block with flex-direction set to row so that header => footer appears
 * from left to right rather than top to bottom
 * 2) Wraps to a stack once the body can no longer hold its basis
 */
.cre8-c-card--horizontal {
  flex-direction: row;
  flex-wrap: wrap;
  /* 2 */
  align-items: center;
  justify-content: center;
}

/**
 * Bare card
 * 1) Organized block without a border, background, or padding
 */
.cre8-c-card--bare {
  border: 0;
  padding: 0;
  gap: 0;
  box-shadow: none;
}

/**
 * Horizontal-bare card
 * 1) Organized block with flex-direction set to row so that header => footer appears
 * from left to right rather than top to bottom without a border, background, or padding
 * 2) Wraps to a stack once the body can no longer hold its basis
 */
.cre8-c-card--horizontal-bare {
  flex-direction: row;
  flex-wrap: wrap;
  /* 2 */
  border: 0;
  padding: 0;
  gap: 0;
  box-shadow: none;
  align-items: center;
  justify-content: center;
}

/**
 * Center aligned card
 * 1) Center content and text within the card
 */
.cre8-c-card--align-center {
  text-align: center;
  /* 1 */
  align-items: center;
  /* 1 */
  justify-content: center;
  /* 1 */
}

/**
 * Slotted image within a card
 * 1) Make the image full width
 */
::slotted(img) {
  width: 100%;
}

/**
 * Card header
 * 1) Remove flex so that body always takes up remaining space
 * 2) ...except in a horizontal card, where holding max-content width would
 * starve the body instead.
 */
.cre8-c-card__header {
  display: block;
  flex: none;
  /* 1 */
}
.cre8-c-card--horizontal .cre8-c-card__header, .cre8-c-card--horizontal-bare .cre8-c-card__header {
  flex: 0 1 auto;
  /* 2 */
}

/**
 * Card body
 * 1) Flex applied to always fill the remaining space of the card
 * 2) In a horizontal card the body is the flexible track, so it needs a basis
 * of its own and \`min-width: 0\`; otherwise it is the only item able to shrink
 * and collapses to min-content beside a wide header.
 */
.cre8-c-card__body {
  display: block;
  flex: 1 1 auto;
  /* 1 */
}
.cre8-c-card--horizontal .cre8-c-card__body, .cre8-c-card--horizontal-bare .cre8-c-card__body {
  flex: 1 1 20rem;
  /* 2 */
  min-width: 0;
  /* 2 */
}

/**
 * Card footer
 * 1) Remove flex so that body always takes up remaining space
 * 2) ...except in a horizontal card - see the note on the header.
 */
.cre8-c-card__footer {
  display: block;
  flex: none;
  /* 1 */
}
.cre8-c-card--bare .cre8-c-card__footer {
  padding: 0;
}
.cre8-c-card--horizontal-bare .cre8-c-card__footer {
  padding: 0;
}
.cre8-c-card--horizontal .cre8-c-card__footer, .cre8-c-card--horizontal-bare .cre8-c-card__footer {
  flex: 0 1 auto;
  /* 2 */
}`;
export default styles;
